import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChevronDown from "../../UI/ChevronDown";
import AlertCircle from "../../UI/AlertCircle";
import CheckCircle from "../../UI/CheckCircle";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
  TextField,
  makeStyles
} from "@material-ui/core";
import { updateReceta } from "../../../../actions/recetasDigitales/RecetasDigitales";
import { SUBTIPOS_RECETAS } from "../../../../utils/constants";

const useStyles = makeStyles((theme) => ({
  texto: {
    padding: 2,
    // marginLeft: 20,
    marginTop: 4,
    width: '89%',
  }
}));

export const RecetasDigitalesAccordionPrescripciones = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { recetaSeleccionada = {} } = useSelector(
    (state) => state.recetasDigitales
  );

  let precripcionReceta = null;

  if (recetaSeleccionada.prescripcion) {
    precripcionReceta = recetaSeleccionada.prescripcion;
  }

  const [prescripcionMedica, setPrescripcionMedica] = useState(precripcionReceta);
  const [titulo, setTitulo] = useState("");

  const changeDiagnosticoHandler = (value) => {
    setPrescripcionMedica(value);
    dispatch(updateReceta("prescripcion", value));
  };

  useEffect(() => {
    props.setDatosCompletos(!!prescripcionMedica);
  }, [prescripcionMedica]);

  useEffect(() => {
    if (recetaSeleccionada.idSubtipoReceta === SUBTIPOS_RECETAS.CERTIFICADO) {
      setTitulo("Certificado");
    } else if (recetaSeleccionada.idSubtipoReceta === SUBTIPOS_RECETAS.INDICACION) {
      setTitulo("Indicacion");
    } else {
      setTitulo("Receta");
    }
  }, [recetaSeleccionada]);

  return (
    <Accordion TransitionProps={{ unmountOnExit: true }} expanded={true}>
      <AccordionSummary expandIcon={<ChevronDown />}>
        <Typography variant="h6">
          {titulo} {props.datosCompletos ? <CheckCircle /> : <AlertCircle />}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid
          container
          spacing={3}
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "0.5rem",
            marginLeft: "1.5rem",
          }}
        >
          <Grid item xs={12} md={12} >
            <TextField
              className={classes.texto}
              name="detalle"
              value={precripcionReceta}
              label="Detalle"
              fullWidth
              multiline
              rows={7}
              rowsMax={8}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                changeDiagnosticoHandler(e.target.value)
              }}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
